import _ from "lodash/fp";
import React from "react";
import {connect} from "react-redux";
import {Button, Glyphicon, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import {createMessage} from "../../stores/messages/createMessage";
import {fetchSigntask} from "../../stores/signtasks/fetchSigntask";
import {exitSigning} from "../../stores/signing/exitSigning";
import {fetchOrderStatus} from "../../stores/signtasks/fetchOrderStatus";

export default connect(
  undefined,
  dispatch => ({
    showError: () => dispatch(createMessage({style: "danger", lines: ["Error during signing."]})),
    showCompleted: name => dispatch(createMessage({style: "success", lines: [`${name} signed the signtask.`]})),
    updateSigntask: _.compose(dispatch, fetchSigntask),
    updateOrderStatus: _.compose(dispatch, fetchOrderStatus)
  })
)(class extends React.Component {
  state = {
    showModal: false,
    isSigning: false,
  };

  signURL = () => `/api/signurl` +
    `/signtask/${this.props.signtask.id}` +
    `/singer/${this.props.signer.ssn}` +
    `/document/${this.props.document.reference}/`;

  startSigning = () => {
    this.setState({showModal: true});
    window.addEventListener("message", this.message);
  };

  finnishSigning = () => {
    this.setState({showModal: false});
    window.removeEventListener("message", this.message);
  };

  message = async event => {
    const data = event.data || {};
    if (data.type !== exitSigning.toString()) return;

    this.finnishSigning();

    switch (data.payload.status) {
      case "error":
        this.props.showError();
        break;

      case "completed":
        this.props.showCompleted(this.props.signtask.signers[data.payload.ssn].name);
        break;

      default:
        return;
    }

    await this.props.updateSigntask(this.props.signtask.id);
    this.props.updateOrderStatus(this.props.signtask.id);
  };

  render = () => {
    return(
      <span>
        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Sign</Tooltip>}>
          <Button onClick={this.startSigning} bsSize="xsmall">
            <Glyphicon glyph="pencil" />
          </Button>
        </OverlayTrigger>

        <Modal show={this.state.showModal} onHide={() => this.finnishSigning(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Signing as {this.props.signer.name} ({this.props.signer.ssn})</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe src={this.signURL()} width="100%" height="800" style={{border: "none"}}/>
          </Modal.Body>
        </Modal>
      </span>
    );
  }
});